import $ from 'jquery';

class Header {
  constructor(target) {
    this.target = target;
    this.navBtn = this.target.find('.header__navBtn');
    this.menu = $('.header__menu');
    this.elem = $('.mainCopy');

    this.navSubBtn = this.menu.find('.header__menu__subBtn');

    this._setHum();
    this._setScroll();
    this._setSubmenu();
  }

  _setHum() {
    this.navBtn.click(
      function () {
        this.menu.toggleClass('header__menu--open');
        this.navBtn.toggleClass('header__navBtn--close');
      }.bind(this),
    );
  }

  _setScroll() {
    $(window).scroll(
      function () {
        var elemOffset = this.elem.offset().top;
        var scrollPos = $(window).scrollTop();
        if (scrollPos > elemOffset) this.target.addClass('header--open');
        else this.target.removeClass('header--open');
        this.menu.removeClass('header__menu--open');
        this.navBtn.removeClass('header__navBtn--close');
      }.bind(this),
    );
  }

  _setSubmenu() {
    this.navSubBtn.click(
      function () {
        this.navSubBtn.toggleClass('header__menu__subBtn--open');
        this.navSubBtn.next().toggleClass('header__menu__subMenu--open');
      }.bind(this),
    );
  }


}
// $(function () {
//   $('.lb-nav-toggle').on('click', function () {
//     $('body').toggleClass('lb-open');
//   });
//   $('header .lb-header a').on('click', function () {
//     $('body').removeClass('lb-open');
//     var speed = 400;
//     var href = $(this).attr('href');
//     var str = href.replace('/', '');
//     var target = $(str == '#' || str == '' ? 'html' : str);
//     var position = target.offset().top - 100;
//     $('body,html').animate({ scrollTop: position }, speed, 'swing');
//   });
// });
(() => {
  const targets = $('.header');
  if (!targets.length) return;
  new Header(targets);
})();
